import React from 'react'

// bootstrap
import {
    Row, Col
} from 'react-bootstrap'

export default function PurchaseOrdersSingleShippingAddress(props) {
    const { sAddress } = props
    return (
        <>
            <Row>
                <Col xs={12} md={9} lg={12} className="px-0">
                    <div className="app-header-wrapper" style={{ paddingLeft: '12px', paddingBottom: '9px', marginBottom: 0 }}>
                        <p className="app-heading text-capitalize app-heading-bold app-heading-label mb-2">Shipping Address</p>
                    </div>
                </Col>
            </Row>

            <div className="app-card-content bg-white border st-border-dark st-default-rounded-block">
                <Row className="pad-20 mx-0" style={{ minHeight: 388 }}>
                    <div className="border-bottom p-0">
                        <Row style={{ margin: "10px 0" }}>
                            <Col xs={12} md={9} lg={5} className="px-0 text-capitalize st-fs-13 st-fw-600 st-text-color2">Full Name: </Col>
                            <Col xs={12} md={9} lg={7} className="px-0 st-fs-16 st-fw-600 st-text-dark2 text-capitalize">{sAddress.shipping_first_name}</Col>
                        </Row>
                    </div>
                    <div className="border-bottom p-0">
                        <Row style={{ margin: "10px 0" }}>
                            <Col xs={12} md={9} lg={5} className="px-0 text-capitalize st-fs-13 st-fw-600 st-text-color2">Company Name: </Col>
                            <Col xs={12} md={9} lg={7} className="px-0 st-fs-16 st-fw-600 st-text-dark2 text-capitalize">{sAddress.shipping_company_name}</Col>
                        </Row>
                    </div>
                    <div className="border-bottom p-0">
                        <Row style={{ margin: "10px 0" }}>
                            <Col xs={12} md={9} lg={5} className="px-0 text-capitalize st-fs-13 st-fw-600 st-text-color2">Mobile Number: </Col>
                            <Col xs={12} md={9} lg={7} className="px-0 st-fs-16 st-fw-600 st-text-dark2">{sAddress.shipping_mobile}</Col>
                        </Row>
                    </div>
                    <div className="border-bottom p-0">
                        <Row style={{ margin: "10px 0" }}>
                            <Col xs={12} md={9} lg={5} className="px-0 text-capitalize st-fs-13 st-fw-600 st-text-color2">Street Address: </Col>
                            <Col xs={12} md={9} lg={7} className="px-0 st-fs-16 st-fw-600 st-text-dark2 text-capitalize">{sAddress.shipping_address}</Col>
                        </Row>
                    </div>
                    <div className="border-bottom p-0">
                        <Row style={{ margin: "10px 0" }}>
                            <Col xs={12} md={9} lg={5} className="px-0 text-capitalize st-fs-13 st-fw-600 st-text-color2">Country: </Col>
                            <Col xs={12} md={9} lg={7} className="px-0 st-fs-16 st-fw-600 st-text-dark2 text-capitalize">{sAddress.country}</Col>
                        </Row>
                    </div>
                    <div className="border-bottom p-0">
                        <Row style={{ margin: "10px 0" }}>
                            <Col xs={12} md={9} lg={5} className="px-0 text-capitalize st-fs-13 st-fw-600 st-text-color2">State/Province: </Col>
                            <Col xs={12} md={9} lg={7} className="px-0 st-fs-16 st-fw-600 st-text-dark2 text-capitalize">{sAddress.state}</Col>
                        </Row>
                    </div>
                    <div className="border-bottom p-0">
                        <Row style={{ margin: "10px 0" }}>
                            <Col xs={12} md={9} lg={5} className="px-0 text-capitalize st-fs-13 st-fw-600 st-text-color2">City: </Col>
                            <Col xs={12} md={9} lg={7} className="px-0 st-fs-16 st-fw-600 st-text-dark2 text-capitalize">{sAddress.city}</Col>
                        </Row>
                    </div>
                    <div className="p-0">
                        <Row style={{ margin: "10px 0" }}>
                            <Col xs={12} md={9} lg={5} className="px-0 text-capitalize st-fs-13 st-fw-600 st-text-color2">Zip/Postal Code: </Col>
                            <Col xs={12} md={9} lg={7} className="px-0 st-fs-16 st-fw-600 st-text-dark2">{sAddress.shipping_zipcode}</Col>
                        </Row>
                    </div>
                </Row>
            </div>
        </>
    )
}
